export { default } from "./OpenAdgangsplatform.page";
